module.exports = __webpack_public_path__ + "img/stretch--genre4_tab-normal.7300f875.png";